import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import validator from "validator";
import { useState } from "react";
import { signoutHandler } from "./LogoutButton";
import Loader from "../Loader";
import { requestForUpdateUserDetails } from "../../api/requests";
import { useDispatch, useSelector } from "react-redux";
import { setIsOneFactor } from "../../actions/auth";
import { useNavigate } from "react-router-dom";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://mui.com/">
        Certificates BO
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const theme = createTheme();

export default function Details() {
  const [phoneValue, setPhoneValue] = useState("+");
  const [isValidPhone, setIsValidPhone] = useState(true);
  const [password, setPassword] = useState("");
  const [isValidPassword, setIsValidPassword] = useState(true);
  const [passwordVerify, setPasswordVerify] = useState("");
  const [isValidPasswordVerify, setIsValidPasswordVerify] = useState(true);
  const [isPasswordVerified, setIsPasswordVerified] = useState(true);
  const [firstName, setFirstName] = useState("");
  const [isValidFirstName, setIsValidFirstName] = useState(true);
  const [lastName, setLastName] = useState("");
  const [isValidLastName, setIsValidLastName] = useState(true);
  const [jobTitle, setJobTitle] = useState("");
  const [isValidJobTitle, setIsValidJobTitle] = useState(true);

  const [isLoading, setIsLoading] = useState(false);

  const token = useSelector((state) => state.auth.token);
  const dispatch = useDispatch();

  let navigate = useNavigate();

  const handleSubmit = async (event) => {
    setIsLoading(true);
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const isFormDataVerified = () => {
      if (firstName === "") {
        setIsValidFirstName(false);
        return false;
      }
      if (lastName === "") {
        setIsValidLastName(false);
        return false;
      }
      if (!validatePhoneNumber(phoneValue)) {
        setIsValidPhone(false);
        return false;
      }
      if (jobTitle === "") {
        setIsValidJobTitle(false);
        return false;
      }
      if (password === "" || password.length < 6) {
        setIsValidPassword(false);
        return false;
      }
      if (passwordVerify === "") {
        setIsValidPasswordVerify(false);
        return false;
      }
      if (password !== passwordVerify) {
        setIsPasswordVerified(false);
        return false;
      }
      return true;
    };
    const isFormDataVerifiedAns = isFormDataVerified();
    if (!isFormDataVerifiedAns) {
      setIsLoading(false);
      return;
    }
    const updateUserDetails = async () => {
      const response = await requestForUpdateUserDetails(data, token);
      let res;
      if (response.status !== 200) {
      } else {
        // Call the .json() method on your response to get your JSON data
        res = await response.json();
        dispatch(setIsOneFactor(false));
        signoutHandler(dispatch);
        navigate("/");
      }
      setIsLoading(false);

      return res;
    };
    await updateUserDetails();
  };

  const validatePhoneNumber = (number) => {
    const isValidPhoneNumber = validator.isMobilePhone(number);
    return isValidPhoneNumber;
  };

  return isLoading ? (
    <Loader />
  ) : (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            More Details
          </Typography>
          <Box
            component="form"
            noValidate
            onSubmit={handleSubmit}
            sx={{ mt: 3 }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  value={firstName}
                  onChange={(e) => {
                    setFirstName(e.target.value);
                    setIsValidFirstName(e.target.value !== "");
                  }}
                  autoComplete="given-name"
                  name="firstName"
                  required
                  fullWidth
                  id="firstName"
                  label="First Name"
                  autoFocus
                  error={!isValidFirstName}
                  helperText={
                    !isValidFirstName ? "First name can not be empty!" : ""
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value);
                    setIsValidLastName(e.target.value !== "");
                  }}
                  required
                  fullWidth
                  id="lastName"
                  label="Last Name"
                  name="lastName"
                  autoComplete="family-name"
                  error={!isValidLastName}
                  helperText={
                    !isValidLastName ? "Last name can not be empty!" : ""
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={phoneValue}
                  onChange={(e) => {
                    setPhoneValue(e.target.value);
                    setIsValidPhone(validatePhoneNumber(e.target.value));
                  }}
                  required
                  fullWidth
                  id="phone"
                  label="Phone Number"
                  name="phone"
                  autoComplete="phone"
                  error={!isValidPhone}
                  helperText={!isValidPhone ? "Illegal phone number" : ""}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={jobTitle}
                  onChange={(e) => {
                    setJobTitle(e.target.value);
                    setIsValidJobTitle(e.target.value !== "");
                  }}
                  required
                  fullWidth
                  id="jobTitle"
                  label="Job Title"
                  name="jobTitle"
                  autoComplete="job-title"
                  error={!isValidJobTitle}
                  helperText={
                    !isValidJobTitle ? "Job title can not be empty!" : ""
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setIsValidPassword(e.target.value !== "");
                  }}
                  required
                  fullWidth
                  name="password"
                  label="New Password"
                  type="password"
                  id="password"
                  autoComplete="password"
                  error={!isValidPassword}
                  helperText={
                    password === ""
                      ? "Password can not be empty!"
                      : password.length < 6
                      ? "Password must be at least 6 characters"
                      : ""
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={passwordVerify}
                  onChange={(e) => {
                    setPasswordVerify(e.target.value);
                    setIsPasswordVerified(e.target.value === password);
                    setIsValidPasswordVerify(e.target.value !== "");
                  }}
                  required
                  fullWidth
                  name="passwordVerify"
                  label="Verify Password"
                  type="password"
                  id="passwordVerify"
                  autoComplete="password verification"
                  error={!isValidPasswordVerify || !isPasswordVerified}
                  helperText={
                    !isValidPasswordVerify
                      ? "Verified Password can not be empty"
                      : !isPasswordVerified
                      ? "Passwords do not match!"
                      : ""
                  }
                />
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Submit Details
            </Button>
          </Box>
        </Box>
        <Copyright sx={{ mt: 5 }} />
      </Container>
    </ThemeProvider>
  );
}
